import gql from "graphql-tag";

export default gql`

fragment RoomTypeAvailableItemFragment on BookingEngineRoomTypeAvailableItem {
  hasDelogement
  categoryIdList
}

`